<script setup lang="ts">
import router from '@/router';
import { useRoute } from 'vue-router';
import { IonContent, IonIcon } from '@ionic/vue';
import { useI18n } from 'vue-i18n';

import ScanQR from '@/shared/components/ScanQR.vue';
import BackButton from '@/shared/components/BackButton.vue';
import TopBar from '@/shared/components/TopBar.vue';

// Init
const { t } = useI18n();
const route = useRoute();

const onScan = async (scannedQrQcode: string) => {
	let urlObj = null;
	try {
		urlObj = new URL(scannedQrQcode);
	} catch (error) {
		console.log(error);
	}

	if (!urlObj) {
		await router.push({
			path: '/merge-qr/' + scannedQrQcode,
		});
	} else {
		const pathname = urlObj.pathname;
		const domain = urlObj.hostname;
		if (pathname.includes('activate')) {
			// Push to the route
			await router.push({
				path: pathname,
			});
		} else if (domain === 'payconiq.com' && scannedQrQcode.includes('R=')) {
			const token = urlObj.searchParams.get('R');
			// Push to the route
			await router.push({
				path: '/activate/' + token,
			});
		} else {
			// Push to the route
			await router.push({
				path: '/merge-qr/' + scannedQrQcode,
			});
		}
	}
};
</script>

<template>
	<ion-content>
		<div class="flex flex-col justify-between h-full">
			<TopBar class="px-[34px]">
				<template #left>
          <BackButton to="/rfid" />
				</template>
			</TopBar>

			<div class="flex items-center justify-center">
				<ScanQR @on-scan-q-r="onScan" :start-camera="true" :permissionTitle="t('scan_qr.camera_permission_title')" :permissionDescription="t('scan_qr.camera_permission_description')"></ScanQR>
			</div>

			<div class="h-[200px]"></div>
		</div>
	</ion-content>
</template>

<style scoped></style>
